import { APIGetRequest, ClientContextResponse } from '@ancon/wildcat-types'

import Request from '../../client/Request'
import endpoints from '../endpoints'

type ClientContextAPI = {
  get: {
    details: APIGetRequest<ClientContextResponse>
  }
}

const clientContext: ClientContextAPI = {
  get: {
    details: new Request(endpoints.core.clientContexts.list).get,
  },
}

export default clientContext
